/* Corsa Forged bespoke order builder */
(function () {
  var DEF = {
    monoblock: { '18': 76500, '19': 86500, '20': 96500, '21': 96500, '22': 96500, '23': 96500, '24': 96500 },
    two_piece: { '18': 101500, '19': 111500, '20': 121500, '21': 121500, '22': 121500, '23': 121500, '24': 121500 },
    beadlock: { '15x10': 96000, '15x12': 132000, '17': 106500, '18': 106500 }
  };
  var UPDEF = { 'UP-W60': 6000, 'UP-W90': 9000, 'UP-W115': 11500, 'UP-FACE-BR': 15000, 'UP-FACE-PO': 17500, 'UP-FACE-SP': 27500, 'UP-BAR-PO': 6000, 'UP-BAR-BR': 7000, 'UP-BAR-SP': 27500 };
  var UPLBL = { 'UP-W60': 'Width 11" to 11.5"', 'UP-W90': 'Width 12"', 'UP-W115': 'Width 12.5" to 13"', 'UP-FACE-BR': 'Brushed face (set)', 'UP-FACE-PO': 'Polished face (set)', 'UP-FACE-SP': 'Chrome or custom face (set)', 'UP-BAR-PO': 'Polished barrel', 'UP-BAR-BR': 'Brushed barrel', 'UP-BAR-SP': 'Chrome or custom barrel (set)' };
  var WIDTHS = ['8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'];

  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var CHEVRON_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(c) {
    var d = Math.round(c) / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function faceTier(name) {
    if (name === 'Brushed Aluminum') return 'BR';
    if (name === 'Polished Aluminum') return 'PO';
    if (name === 'Chrome' || name === 'Bronze Chrome' || name === 'Custom color') return 'SP';
    return null;
  }
  function widthKey(w) {
    w = parseFloat(w);
    if (w >= 12.5) return 'UP-W115';
    if (w >= 12) return 'UP-W90';
    if (w >= 11) return 'UP-W60';
    return null;
  }

  /* Swatch dropdown on top of a native select (same as the quote form). */
  function enhanceFinish(select, onChange) {
    var label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    var wrap = el('div', 'cq__pick');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('cq__sr');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    var btn = el('button', 'cq__trig');
    btn.type = 'button';
    btn.id = select.id + '-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var sw = el('span', 'cq__sw'); sw.setAttribute('aria-hidden', 'true');
    var name = el('span', 'cq__trig-name');
    var note = el('span', 'cq__trig-note');
    var chev = el('span'); chev.innerHTML = CHEVRON_SVG; chev.style.display = 'inline-flex';
    btn.appendChild(sw); btn.appendChild(name); btn.appendChild(note); btn.appendChild(chev);
    wrap.appendChild(btn);
    if (label) {
      if (!label.id) label.id = select.id + '-lbl';
      label.setAttribute('for', btn.id);
      btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
    }
    var list = el('div', 'cq__list');
    list.id = select.id + '-list';
    list.setAttribute('role', 'listbox');
    if (label) list.setAttribute('aria-labelledby', label.id);
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);
    var optButtons = [];
    Array.prototype.forEach.call(select.children, function (child) {
      var group = el('div');
      var opts = [];
      if (child.tagName === 'OPTGROUP') {
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', child.label);
        group.appendChild(el('div', 'cq__group-title', child.label));
        opts = Array.prototype.slice.call(child.children);
      } else {
        opts = [child];
      }
      opts.forEach(function (o) {
        var b = el('button', 'cq__opt');
        b.type = 'button';
        b.setAttribute('role', 'option');
        b.setAttribute('data-value', o.value);
        var s = el('span', 'cq__sw'); s.setAttribute('aria-hidden', 'true'); s.style.background = o.getAttribute('data-bg') || '#ccc';
        b.appendChild(s);
        b.appendChild(el('span', 'cq__opt-name', o.value));
        if (o.getAttribute('data-note')) b.appendChild(el('span', 'cq__opt-note', o.getAttribute('data-note')));
        var ck = el('span', 'cq__check'); ck.innerHTML = CHECK_SVG; b.appendChild(ck);
        b.addEventListener('click', function () {
          select.value = o.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          close(true);
        });
        group.appendChild(b);
        optButtons.push(b);
      });
      list.appendChild(group);
    });
    wrap.appendChild(list);
    function sync() {
      var o = select.options[select.selectedIndex];
      if (!o) return;
      sw.style.background = o.getAttribute('data-bg') || '#ccc';
      name.textContent = o.value;
      note.textContent = o.getAttribute('data-note') || '';
      optButtons.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-value') === o.value ? 'true' : 'false'); });
    }
    function open() {
      document.dispatchEvent(new CustomEvent('cq:close-all', { detail: wrap }));
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var cur = list.querySelector('[aria-selected="true"]') || optButtons[0];
      if (cur) { cur.focus(); cur.scrollIntoView({ block: 'nearest' }); }
    }
    function close(refocus) {
      if (list.hidden) return;
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (refocus) btn.focus();
    }
    btn.addEventListener('click', function () { list.hidden ? open() : close(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      var i = optButtons.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (optButtons[i + 1]) optButtons[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) optButtons[i - 1].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); optButtons[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); optButtons[optButtons.length - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'Tab') { close(false); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });
    document.addEventListener('cq:close-all', function (e) { if (e.detail !== wrap) close(false); });
    select.addEventListener('change', function () { sync(); if (onChange) onChange(); });
    sync();
  }

  function init(root) {
    if (root.__cqbReady) return;
    root.__cqbReady = true;
    var dataEl = root.parentNode.querySelector('[data-cqb-data]') || document.querySelector('[data-cqb-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; }
    var cons = data.cons || root.getAttribute('data-cons') || 'monoblock';
    var form = root.querySelector('[data-cqb-form]');
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* Sizes: from real variants when the product has them, otherwise the default table (estimate only). */
    var sizes = {};
    var live = !!(data.hasSize && data.variants && data.variants.length);
    if (live) {
      data.variants.forEach(function (v) { sizes[String(v.size).toLowerCase().replace(/\s|"/g, '')] = v; });
    } else {
      var t = DEF[cons] || DEF.monoblock;
      Object.keys(t).forEach(function (k) { sizes[k] = { id: null, price: t[k], plan: null, due: null, available: true }; });
    }
    var ups = {};
    Object.keys(UPDEF).forEach(function (k) {
      var u = data.upgrades && data.upgrades[k];
      ups[k] = u ? u : { id: null, price: UPDEF[k], plan: null };
    });
    var ratio = null;
    if (live) {
      var pv = data.variants.filter(function (v) { return v.due != null && v.price; })[0];
      if (pv) ratio = pv.due / pv.price;
    }

    var diams = [];
    Object.keys(sizes).forEach(function (k) { var d = k.split('x')[0]; if (diams.indexOf(d) < 0) diams.push(d); });
    diams.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    function widthsFor(d) {
      var exact = Object.keys(sizes).filter(function (k) { return k.indexOf(d + 'x') === 0; }).map(function (k) { return k.split('x')[1]; });
      return exact.length ? { list: exact, exact: true } : { list: WIDTHS, exact: false };
    }
    function minFor(d) {
      var m = null;
      Object.keys(sizes).forEach(function (k) { if (k.split('x')[0] === d && (m === null || sizes[k].price < m)) m = sizes[k].price; });
      return m;
    }
    function sizeFor(d, w) { return sizes[d + 'x' + w] || sizes[d] || null; }

    /* Fill diameter and width dropdowns. */
    function fillDiam(sel, def) {
      sel.innerHTML = '';
      diams.forEach(function (d) {
        var o = el('option', null, d + '"  (' + (widthsFor(d).exact ? 'from ' : '') + money(minFor(d)) + ' per wheel)');
        o.value = d;
        sel.appendChild(o);
      });
      sel.value = diams.indexOf(def) >= 0 ? def : diams[0];
    }
    function fillWidth(sel, d, keep) {
      var info = widthsFor(d);
      sel.innerHTML = '';
      info.list.forEach(function (w) {
        var txt = w + '"';
        if (info.exact) {
          txt += '  (' + money(sizes[d + 'x' + w].price) + ' per wheel)';
        } else {
          var k = widthKey(w);
          if (k) txt += '  (+' + money(ups[k].price) + ' per wheel)';
        }
        var o = el('option', null, txt);
        o.value = w;
        sel.appendChild(o);
      });
      sel.value = info.list.indexOf(keep) >= 0 ? keep : info.list[Math.min(1, info.list.length - 1)];
      if (info.list.indexOf(keep) < 0 && info.list.indexOf('9.5') >= 0) sel.value = '9.5';
    }
    var dF = q('[data-cqb-diam="front"]'), wF = q('[data-cqb-width="front"]');
    var dR = q('[data-cqb-diam="rear"]'), wR = q('[data-cqb-width="rear"]');
    if (cons === 'beadlock') {
      fillDiam(dF, '18'); fillWidth(wF, dF.value, '9');
      fillDiam(dR, '17'); fillWidth(wR, dR.value, '10');
    } else {
      fillDiam(dF, '20'); fillWidth(wF, dF.value, '9.5');
      fillDiam(dR, '21'); fillWidth(wR, dR.value, '11.5');
    }
    dF.addEventListener('change', function () { fillWidth(wF, dF.value, wF.value); });
    dR.addEventListener('change', function () { fillWidth(wR, dR.value, wR.value); });

    /* Finish notes with prices, then swatch dropdowns. */
    qa('[data-cqb-finish]').forEach(function (s) {
      var isBarrel = s.getAttribute('data-cqb-finish') === 'barrel';
      Array.prototype.forEach.call(s.querySelectorAll('option'), function (o) {
        var t = faceTier(o.value);
        var note = '';
        if (t === 'SP') note = '+' + money(ups[isBarrel ? 'UP-BAR-SP' : 'UP-FACE-SP'].price) + '/set';
        else if (t && isBarrel) note = '+' + money(ups['UP-BAR-' + t].price) + '/wheel';
        else if (t) note = '+' + money(ups['UP-FACE-' + t].price) + '/set';
        if (note) o.setAttribute('data-note', note); else o.removeAttribute('data-note');
        o.textContent = o.value + (note ? ' (' + note + ')' : '');
      });
    });

    var error = q('[data-cqb-error]');
    var submit = q('[data-cqb-submit]');
    var linesEl = q('[data-cqb-lines]');
    var quoteLink = q('.cq__link');
    var out = function (k, t) { var n = q('[data-cqb-out="' + k + '"]'); if (n) n.textContent = t; };
    var val = function (k) { var n = q('[data-k="' + k + '"]'); return n ? n.value.trim() : ''; };
    var finishName = function (which) {
      var s = q('[data-cqb-finish="' + which + '"]');
      if (!s) return '';
      if (s.value === 'Custom color') {
        var c = q('[data-cqb-custom="' + which + '"]');
        return c && c.value.trim() ? 'Custom: ' + c.value.trim() : 'Custom color';
      }
      return s.value;
    };

    function build() {
      var bead = cons === 'beadlock';
      var qtyMode = (form.querySelector('[data-cqb-qty]:checked') || {}).value || 'set';
      var setup = (form.querySelector('[data-cqb-setup]:checked') || {}).value || 'staggered';
      var groups = [];
      if (bead) {
        if (qtyMode === 'pair') groups.push({ pos: 'Rear', d: dR.value, w: wR.value, qty: 2 });
        else { groups.push({ pos: 'Front', d: dF.value, w: wF.value, qty: 2 }); groups.push({ pos: 'Rear', d: dR.value, w: wR.value, qty: 2 }); }
      } else if (setup === 'square') {
        groups.push({ pos: 'All four', d: dF.value, w: wF.value, qty: 4 });
      } else {
        groups.push({ pos: 'Front', d: dF.value, w: wF.value, qty: 2 });
        groups.push({ pos: 'Rear', d: dR.value, w: wR.value, qty: 2 });
      }
      /* show / hide boxes */
      var showFront = !(bead && qtyMode === 'pair');
      var showRear = bead || setup === 'staggered';
      q('[data-cqb-group="front"]').hidden = !showFront;
      q('[data-cqb-group="rear"]').hidden = !showRear;
      q('[data-cqb-title="front"]').textContent = (!bead && setup === 'square') ? 'All four wheels' : 'Front';
      q('[data-cqb-title="rear"]').textContent = bead ? 'Rear bead-locks' : 'Rear';

      var lines = [];
      var wheels = 0;
      var ok = live;
      groups.forEach(function (g) {
        var s = sizeFor(g.d, g.w);
        var exact = !!sizes[g.d + 'x' + g.w];
        wheels += g.qty;
        if (!s || !s.id) ok = false;
        lines.push({ kind: 'wheel', group: g, size: s, qty: g.qty, price: s ? s.price : 0, label: g.qty + ' x ' + g.d + '" x ' + g.w + '" ' + g.pos.toLowerCase() });
        var wk = exact ? null : widthKey(g.w);
        if (wk) lines.push({ kind: 'up', key: wk, qty: g.qty, price: ups[wk].price, label: g.qty + ' x ' + UPLBL[wk] });
      });
      var ft = faceTier(q('[data-cqb-finish="face"]').value);
      if (ft) lines.push({ kind: 'up', key: 'UP-FACE-' + ft, qty: 1, price: ups['UP-FACE-' + ft].price, label: UPLBL['UP-FACE-' + ft] });
      var barrelSel = q('[data-cqb-finish="barrel"]');
      if (barrelSel) {
        var bt = faceTier(barrelSel.value);
        if (bt === 'SP') lines.push({ kind: 'up', key: 'UP-BAR-SP', qty: 1, price: ups['UP-BAR-SP'].price, label: UPLBL['UP-BAR-SP'] });
        else if (bt) lines.push({ kind: 'up', key: 'UP-BAR-' + bt, qty: wheels, price: ups['UP-BAR-' + bt].price, label: wheels + ' x ' + UPLBL['UP-BAR-' + bt] });
      }
      lines.forEach(function (l) { if (l.kind === 'up' && !ups[l.key].id) ok = false; });
      var total = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);

      /* custom color boxes */
      qa('[data-cqb-finish]').forEach(function (s) {
        var box = s.closest('.cq__finish').querySelector('[data-cq-custom]');
        if (box) box.hidden = s.value !== 'Custom color';
      });

      var veh = [val('year'), val('make'), val('model')].filter(Boolean).join(' ');
      out('vehicle', veh || 'Add your vehicle');
      out('size', groups.map(function (g) { return (groups.length > 1 ? g.pos.charAt(0) + ' ' : '') + g.d + '" x ' + g.w + '"'; }).join('  /  ') + (groups.length === 1 && groups[0].qty === 4 ? ' all four' : ''));
      out('fit', (form.querySelector('[data-cqb-fit]:checked') || {}).value || '');
      out('finish', barrelSel ? 'Face: ' + finishName('face') + '  /  Barrel: ' + finishName('barrel') : finishName('face'));

      linesEl.innerHTML = '';
      lines.forEach(function (l) {
        var row = el('div', 'cq__line');
        row.appendChild(el('span', null, l.label));
        row.appendChild(el('span', null, money(l.price * l.qty)));
        linesEl.appendChild(row);
      });
      out('total', money(total));
      var dueBox = q('[data-cqb-due]');
      if (ratio) { dueBox.hidden = false; out('due', money(total * ratio)); } else { dueBox.hidden = true; }

      if (ok) {
        submit.textContent = ratio ? 'Order now, pay ' + money(total * ratio) + ' today' : 'Add to cart · ' + money(total);
      } else {
        submit.textContent = 'Request this build';
      }
      return { ok: ok, lines: lines, total: total, groups: groups, veh: veh };
    }

    qa('[data-cqb-finish]').forEach(function (s) { enhanceFinish(s, build); });
    form.addEventListener('change', build);
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim()) e.target.removeAttribute('aria-invalid');
      build();
    });
    build();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = build();
      if (!b.ok) { window.location.href = quoteLink.getAttribute('href'); return; }
      var missing = qa('[required]').filter(function (f) { return !f.value.trim(); });
      qa('[required]').forEach(function (f) { if (f.value.trim()) f.removeAttribute('aria-invalid'); else f.setAttribute('aria-invalid', 'true'); });
      if (missing.length) {
        error.textContent = 'Add your make and model so we can check fitment for your car.';
        error.hidden = false;
        missing[0].focus();
        return;
      }
      error.hidden = true;
      var buildId = 'CF-' + Date.now().toString(36).toUpperCase();
      var base = { '_Build': buildId, 'Vehicle': b.veh, 'Fitment': (form.querySelector('[data-cqb-fit]:checked') || {}).value || '' };
      if (val('trim')) base['Trim / brakes'] = val('trim');
      var barrelSel = q('[data-cqb-finish="barrel"]');
      if (barrelSel) { base['Face finish'] = finishName('face'); base['Barrel finish'] = finishName('barrel'); }
      else base['Finish'] = finishName('face');
      if (val('notes')) base['Notes'] = val('notes');
      var items = [];
      b.lines.forEach(function (l) {
        var props, id, plan;
        if (l.kind === 'wheel') {
          props = Object.assign({}, base, { 'Position': l.group.pos, 'Size': l.group.d + '" x ' + l.group.w + '"' });
          id = l.size.id; plan = l.size.plan;
        } else {
          props = { '_Build': buildId, 'For': data.title + ' build' };
          id = ups[l.key].id; plan = ups[l.key].plan;
        }
        var it = { id: id, quantity: l.qty, properties: props };
        if (plan) it.selling_plan = plan;
        items.push(it);
      });
      submit.disabled = true;
      submit.textContent = 'Adding your build...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Something went wrong.');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          submit.disabled = false;
          build();
          error.textContent = 'We could not add this build to your cart. ' + err.message + ' You can request it as a quote instead.';
          error.hidden = false;
        });
    });
  }

  function boot() { document.querySelectorAll('[data-cqb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
